<template>
  <div class="agent-trade-role">
    <div class="section">
      <div class="filter-wrapper">
        <span>{{$t('proxy.text41')}}：</span>
        <el-input clearable v-model="rolename" style="width: 220px;" />
        <span class="ml-40">{{$t('followOrder.text71')}}：</span>
        <el-select
          v-model="status"
          placeholder=""
          size="large"
          style="width: 240px"
        >
          <el-option :label="$t('proxy.text95')" value="" />
          <el-option :label="$t('proxy.text47')" value="1" />
          <el-option :label="$t('proxy.text199')" value="0" />
        </el-select>
        <el-button class="ml-40" type="primary" @click="handleSearch">{{$t('proxy.text13')}}</el-button>
      </div>
      <div class="data-wrapper">
        <el-table
          :data="subGroups"
          header-row-class-name="data-header"
          header-cell-class-name="data-header-cell"
          style="width: 100%"
        >
          <el-table-column prop="rulesGroupID" :label="$t('proxy.text247')" width="180" />
          <el-table-column prop="rulesGroupLevelName" :label="$t('fundHistory.text48')" width="200" align="center" />
          <el-table-column prop="rulesGroupName" :label="$t('proxy.text41')" width="300" align="center" />
          <el-table-column prop="statusStr" :label="$t('proxy.text248')" width="200" />
          <el-table-column prop="edit" :label="$t('proxy.text139')" width="200" fixed="right">
            <template #default="scope">
              <el-button link type="primary" size="small" @click="editHandler(scope.row)">{{$t('proxy.text68')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <el-pagination
      :current-page="currentPage"
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
      :page-size="pageSize"
      :total="total"
      :page-sizes="[10, 50, 100, 200]"
      :disabled="false"
      :background="true"
      layout="total, prev, pager, next, sizes"
      class="pagination-container"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import apiService from '@/api/request'; // 假设 apiService 在此路径
import { useI18n } from "vue-i18n";

const router = useRouter();
const route = useRoute();

const rolename = ref('');
const status = ref('');
const subGroups = ref([]);
const total = ref(0);
const pageSize = ref(10);
const currentPage = ref(1);
const t = useI18n().t;

const handleSearch = () => {
  currentPage.value = 1;
  fetchSubGroups();
};

// 获取下级规则组数据
const fetchSubGroups = () => {
  const rulesGroupId = route.query.rulesGroupID; // 从URL参数获取rulesGroupID
  const params = {
    rulesGroupId: rulesGroupId,
    name: rolename.value,
    status: status.value,
    page: currentPage.value,
    limit: pageSize.value,
  };
  
  apiService.proxySubRulesGroupList(params)
    .then((response) => {
      if (response.status === 1) {
        subGroups.value = response.data.list;
        total.value = response.data.count;
      } else {
        ElMessage.error(t("proxy.text252"));
      }
    })
    .catch(() => {
      ElMessage.error(t("proxy.text252"));
    });
};

// 页码变化
const handlePageChange = (page) => {
  currentPage.value = page;
  fetchSubGroups();
};

// 页大小变化
const handleSizeChange = (size) => {
  pageSize.value = size;
  fetchSubGroups();
};

// 编辑操作
const editHandler = (row) => {
  router.push({
    name: 'agentTradeRoleEdit',
    query: { rulesGroupID: row.rulesGroupID, groupName: row.rulesGroupName, activeMenu: 'traderole' },
  });
};

// 页面加载时获取下级规则组
fetchSubGroups();
</script>

<style scoped>
.filter-wrapper {
  padding: 20px 0;
}

.el-button--link {
  color: #0D9172 !important;
}

.el-button {
  font-size: 16px !important;
}
</style>
